import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';

export interface SwitchConfirmDialogData {
    fromComponent: 'Collection' | 'Playlist';
    toComponent: 'Collection' | 'Playlist';
}

@Component({
    selector: 'app-dialog-switch-confirm',
    templateUrl: './dialog-switch-confirm.component.html',
    styleUrls: ['./dialog-switch-confirm.component.scss'],
    standalone: false
})
export class DialogSwitchConfirmComponent {

    constructor(
        public dialogRef: MatDialogRef<DialogSwitchConfirmComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SwitchConfirmDialogData,
        private translocoService: TranslocoService
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}